import Body from '@/components/body';
import Header from '@/components/header';
import '../scss/root.scss';
import Loading from 'react-loading-bar';
import { useSelector, useThemeConfig } from 'topwrite';
import { SidebarProvider } from '@/lib/use-sidebar';

export default function Root() {

    const { loading } = useSelector('page');
    const { primaryColor } = useThemeConfig();

    return <SidebarProvider>
        <Loading show={loading} color={primaryColor} />
        <Header />
        <Body />
    </SidebarProvider>;
}
